/** @jsx jsx */
/** @jsxRuntime classic */

import { jsx } from '@emotion/react';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/ban-types
type Props = React.PropsWithChildren<{}>;

const Table: React.FC<Props> = ({ children }) => (
  <table
    className="origami-Table-root"
    css={{
      display: 'table',
      width: '100%',
    }}
  >
    {children}
  </table>
);

export default Table;
